module.exports = __webpack_public_path__ + "static/media/mind.bfb21a23.svg";